import React, { ReactElement, ReactNode, useEffect, useState } from "react"
import { getOnlineSessionWindowStatus } from "./online-session-util"

interface OnlineSessionStatusChildProps {
  slot: SlotName;
  children: ReactNode;
}
export const OnlineSessionStatusChild: React.FC<OnlineSessionStatusChildProps> = ({ children }) => {
  return <>{children}</>;
};


type SlotName = "available" | "not_available" | 'before_window' | 'after_window';

interface OnlineSessionStatusProps {
  sessionISODateString: string
  startTimeString: string
  endTimeString: string
  timezone: string
  children: React.ReactElement<OnlineSessionStatusChildProps> | React.ReactElement<OnlineSessionStatusChildProps>[];
  refreshInterval?: number
}

export const OnlineSessionStatus = (props: OnlineSessionStatusProps) => {

  const [status, setStatus] = useState<ReturnType<typeof getOnlineSessionWindowStatus>>()

  function updateStatus() {
    const _status = getOnlineSessionWindowStatus({
      sessionISODateString: props.sessionISODateString,
      startTimeString: props.startTimeString,
      endTimeString: props.endTimeString,
      timezone: props.timezone
    })
    setStatus(_status)
  }

  useEffect(() => {
    updateStatus()
    const intervalId = setInterval(() => {
      updateStatus()
    }, props.refreshInterval ?? 30 * 1000)

    return () => clearInterval(intervalId)
  }, [])

  const withinWindow = status?.available

  return (
    <>
      {withinWindow && React.Children.map(props.children, (child) => {
        if(child.props.slot === 'available')
          return child
      })}
      {!withinWindow && React.Children.map(props.children, (child) => {
        if(child.props.slot === 'not_available')
          return child
      })}
      {!status?.opened && React.Children.map(props.children, (child) => {
        if(child.props.slot === 'before_window')
          return child
      })}
      {status?.closed && React.Children.map(props.children, (child) => {
        if(child.props.slot === 'after_window')
          return child
      })}
    </>
  )
}
